"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var checkIsIntegerNumber_1 = __importDefault(require("../utils/checkIsIntegerNumber"));
var checkIsFieldTypeText = function (fieldType) { return (fieldType === 'text'); };
var checkIsFieldTypeNumber = function (fieldType) { return (fieldType === 'int'); };
var useTextFieldState = function (initValue, changeCallback, settings) {
    if (initValue === void 0) { initValue = ''; }
    var _a = (settings || {}).fieldType, fieldType = _a === void 0 ? 'text' : _a;
    var _b = (0, react_1.useState)(function () { return initValue; }), value = _b[0], setValue = _b[1];
    var handlerChangeValue = (0, react_1.useCallback)(function (event) {
        var value = event.target.value;
        if (checkIsFieldTypeText(fieldType)
            || (checkIsFieldTypeNumber(fieldType) && (value === '' || (0, checkIsIntegerNumber_1.default)(value))))
            setValue(value);
        if (changeCallback)
            changeCallback(event);
    }, [setValue, changeCallback, fieldType]);
    var resetValue = (0, react_1.useCallback)(function () {
        setValue(initValue);
    }, [setValue, initValue]);
    return [value, handlerChangeValue, setValue, resetValue];
};
exports.default = useTextFieldState;
